// extracted by mini-css-extract-plugin
module.exports = {"removeBtnWrapper":"RemoveButton_removeBtnWrapper__NnrwX","removeConfirmBtn":"RemoveButton_removeConfirmBtn__u3MU2","showRemoveConfirm":"RemoveButton_showRemoveConfirm__Rg7Ga"};